/* =====================================================================
   Superette × Notify Me (v1.7, Wishlist V3) — Klaviyo Back in Stock + Fish "Notify Me" list
   ⚠ JavaScript. Never paste into the Fish Wishlist Custom CSS box.
   Loaded from snippets/wishlist-redirect.liquid (window.spWishlist has the customer).

   Product tagged notify-me:
     + label: coming soon  → every size shows NOTIFY ME in place of Add to cart
     only notify-me        → sold out sizes (envelope) show NOTIFY ME, in-stock sizes Add to cart
   Same experience everywhere a notify size can be tapped:
     PDP button · collection / search cards (desktop quick add sizes) ·
     product recommenders · mobile quick add drawer.
     The old TWC notify drawer is never opened.
   Tapping a size:
     1. Klaviyo back in stock subscription for that exact size (email, + SMS if they have / give a mobile)
     2. signed in → also saved to their Fish "Notify Me" list (WL10), silently (never the main wishlist)
     3. email marketing: anyone not already subscribed is subscribed to email (needed to receive the
        alert); the sheet says so under the button — no tick box
        SMS: tick box only if there's no mobile on file
     Signed in + already subscribed + mobile on file → one tap, no sheet, just a confirmation.
   v1.6 (V3): "How should we let you know?" — Email · Text · Both (remembered in this browser), and saved on
     their Klaviyo profile as "Notify Me Channel" (Email / Text / Both) for flow splits.
     Text / Both with no mobile on file asks for it and signs them up to Superette texts; the alert is
     sent on the channels they picked. Email marketing is only added when Email is one of them.
     One tap once their choice is remembered and we have what it needs (email subscribed / mobile).
   v1.7 (V3, consent): nothing is pre-ticked. Alerts are sent by Klaviyo's native Back in Stock flow, which emails
     everyone who asked — so for Email / Both the marketing box is OPTIONAL (unticked, only shown to people not yet
     subscribed). Text / Both → an unticked SMS consent box they must tick (Klaviyo needs SMS consent). Guests always get the sheet (no one-tap); only their email is
     remembered on this device (pre-filled), never their mobile. Signed-in customers can still one-tap once
     they've consented to the channel they chose.
   v1.8 (V3): EMAIL ONLY for launch. Text / Both are switched off with CONFIG.smsEnabled = false — the pills,
     mobile field and SMS consent box aren't shown and every alert is an email. Set it to true to bring
     SMS back (v2); nothing else needs changing.
     No one tap: every Notify me opens the sheet (signed in → email already filled in), so it's always clear
     they're signing up, and anyone not yet subscribed sees the optional email opt-in.
   ===================================================================== */
(() => {
  const CONFIG = {
    klaviyoCompanyId: 'SuDUu6',
    klaviyoListId: 'RbpNVF', // "Superette Master List (Shopify)" — confirm before go-live
    klaviyoSource: 'Notify me',
    revision: '2025-10-15', // 2024-10-15 rejects profile.subscriptions, so the email opt-in silently failed
    notifyListId: 'WL10',
    privacyUrl: '/policies/privacy-policy',
    smsEnabled: false, // v2: true brings back Email · Text · Both
  };
  const me = window.spWishlist || {};
  const loggedIn = !!me.loggedIn;
  const DONE_KEY = 'spNotified';
  const GUEST_KEY = 'spNotifyGuest';
  const CHANNEL_KEY = 'spNotifyChannel'; // 'email' | 'sms' | 'both'
  const usesEmail = (c) => c !== 'sms';
  const usesSms = (c) => c === 'sms' || c === 'both';
  const pickChannel = (c) => (CONFIG.smsEnabled && c ? c : 'email'); // email only until SMS is switched on
  const ls = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k) || 'null') || d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const waitFor = async (fn, timeout = 4000) => {
    const end = Date.now() + timeout;
    while (Date.now() < end) { const v = fn(); if (v) return v; await wait(80); }
    return null;
  };
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const toE164 = (raw) => {
    const v = (raw || '').replace(/[^\d+]/g, '');
    if (!v) return '';
    if (v.startsWith('+')) return v;
    if (v.startsWith('00')) return `+${v.slice(2)}`;
    if (/^04\d{8}$/.test(v)) return `+61${v.slice(1)}`; // AU mobile
    if (v.startsWith('0')) return `+64${v.slice(1)}`; // NZ mobile
    return `+64${v}`;
  };
  const isDone = (id) => ls.get(DONE_KEY, []).includes(String(id));

  /* ---------- Klaviyo (client APIs, public key only) ---------- */
  const kPost = (path, data) => fetch(`https://a.klaviyo.com/client/${path}/?company_id=${CONFIG.klaviyoCompanyId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', revision: CONFIG.revision },
    body: JSON.stringify({ data }),
  }).then((r) => r.ok);
  // V3 · their choice saved on the Klaviyo profile, so flows can split on it:
  // profile property "Notify Me Channel" = "Email" | "Text" | "Both" (+ "Notify Me Channel Updated" date)
  const CHANNEL_LABEL = { email: 'Email', sms: 'Text', both: 'Both' };
  const saveChannel = (email, phone, channel) => {
    const attributes = {
      properties: { 'Notify Me Channel': CHANNEL_LABEL[channel] || 'Email', 'Notify Me Channel Updated': new Date().toISOString() },
    };
    if (email) attributes.email = email; else if (phone) attributes.phone_number = phone; else return Promise.resolve(false);
    return kPost('profiles', { type: 'profile', attributes }).catch(() => false);
  };
  // back in stock for one size; email always, SMS only with a number
  const subscribeBis = (variantId, email, phone, channel = 'email') => {
    const attributes = {};
    if (email) attributes.email = email;
    if (phone) attributes.phone_number = phone;
    const channels = [];
    if (email && usesEmail(channel)) channels.push('EMAIL');
    if (phone && usesSms(channel)) channels.push('SMS');
    if (!channels.length && email) channels.push('EMAIL');
    return kPost('back-in-stock-subscriptions', {
      type: 'back-in-stock-subscription',
      attributes: { channels, profile: { data: { type: 'profile', attributes } } },
      relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } } },
    });
  };
  // marketing consent (only when they tick the boxes)
  const subscribeMarketing = (email, phone, wantEmail, wantSms) => {
    if (!wantEmail && !wantSms) return Promise.resolve(true);
    const subscriptions = {};
    if (wantEmail) subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };
    if (wantSms && phone) subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    const attributes = { email, subscriptions };
    if (phone) attributes.phone_number = phone;
    return kPost('subscriptions', {
      type: 'subscription',
      attributes: { custom_source: CONFIG.klaviyoSource, profile: { data: { type: 'profile', attributes } } },
      relationships: { list: { data: { type: 'list', id: CONFIG.klaviyoListId } } },
    });
  };

  /* ---------- reporting: a "Notify Me Requested" event with clean fields (brand, type, size …) ----------
     Klaviyo's own "Subscribed to Back in Stock" event keeps brand and type inside its Categories list,
     so reports can't group by them. This extra event can be grouped by any of its properties. */
  const productCache = {};
  const productInfo = (url) => {
    const path = String(url || '').split('?')[0].split('#')[0].replace(/\/$/, '');
    if (!/\/products\//.test(path)) return Promise.resolve(null);
    if (!productCache[path]) {
      productCache[path] = fetch(`${path}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null)).catch(() => null);
    }
    return productCache[path];
  };
  const trackNotify = async (ctx, email, channel, emailOptIn) => {
    try {
      const p = (await productInfo(ctx.productUrl)) || {};
      const v = (p.variants || []).find((x) => String(x.id) === String(ctx.variantId)) || {};
      const tags = Array.isArray(p.tags) ? p.tags : [];
      const comingSoon = !!ctx.comingSoon || tags.some((t) => /label:\s*coming soon/i.test(t));
      await kPost('events', {
        type: 'event',
        attributes: {
          properties: {
            Brand: p.vendor || ctx.vendor || '',
            'Product Type': p.type || '',
            'Product Name': p.title || ctx.title || '',
            Size: ctx.size || (v.title && v.title !== 'Default Title' ? v.title : 'One size'),
            SKU: v.sku || '',
            Price: typeof v.price === 'number' ? v.price / 100 : null,
            'Product ID': p.id ? String(p.id) : '',
            'Variant ID': String(ctx.variantId || ''),
            Reason: comingSoon ? 'Coming soon' : 'Restock',
            Launch: tags.some((t) => String(t).trim().toLowerCase() === 'launch'),
            'Signed In': loggedIn,
            Channel: CHANNEL_LABEL[channel] || 'Email',
            'Email Opt-in': !!emailOptIn,
            Source: ctx.source || '',
            'Product URL': p.handle ? `${location.origin}/products/${p.handle}` : '',
            'Image URL': String(ctx.image || '').replace(/^\/\//, 'https://'),
          },
          metric: { data: { type: 'metric', attributes: { name: 'Notify Me Requested' } } },
          profile: { data: { type: 'profile', attributes: { email } } },
          unique_id: `nm-${ctx.variantId}-${Date.now()}`,
        },
      });
    } catch (x) { /* reporting only: never blocks the sign-up */ }
  };

  /* ---------- Fish: save to the "Notify Me" list without opening the drawer ---------- */
  // Fish reads data-wishlist-id when the element is created, so build it with every attribute
  // already in place (createElement + dataset would save to the main wishlist instead).
  const fishButton = (variantId) => {
    document.querySelectorAll('body > wishlist-button-pdp.sp-notify-fish').forEach((el) => el.remove());
    const id = String(variantId).replace(/[^\d]/g, '');
    const wrap = document.createElement('div');
    wrap.innerHTML = `<wishlist-button-pdp data-wishlist-id="${CONFIG.notifyListId}" role="button" class="fish-wishlist-button--pdp sp-notify-fish" aria-hidden="true" tabindex="-1" data-variant-id="${id}" data-preselected-id="${id}" data-is-added="false"></wishlist-button-pdp>`;
    const fish = wrap.firstElementChild;
    document.body.appendChild(fish);
    return fish;
  };
  const saveToFish = async (variantId) => {
    if (!loggedIn) return false;
    const root = document.documentElement;
    root.dataset.spSilent = 'true';
    const settle = async () => {
      await wait(150);
      document.querySelectorAll('fw2-drawer, atw-drawer').forEach((d) => { if (d.dataset.open === 'true' && typeof d.close === 'function') d.close(); });
    };
    try {
      const fish = fishButton(variantId);
      if (!fish) return false;
      await wait(600); // let Fish upgrade it and read the list state
      if (fish.dataset.isAdded === 'true') return true; // already on their Notify Me list
      fish.click();
      const ok = await waitFor(() => fish.dataset.isAdded === 'true', 4000);
      await settle();
      return !!ok;
    } finally {
      setTimeout(() => { delete root.dataset.spSilent; }, 600);
    }
  };

  /* ---------- confirmation toast (same look as the wishlist toast) ---------- */
  let toastTimer;
  const toast = (text) => {
    let el = document.querySelector('.sp-wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sp-wl-toast';
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="sp-wl-toast__text"></span><button type="button" class="sp-wl-toast__action"></button>';
      document.body.appendChild(el);
    }
    el.querySelector('.sp-wl-toast__text').textContent = text;
    const action = el.querySelector('.sp-wl-toast__action');
    action.hidden = !loggedIn;
    action.textContent = loggedIn ? 'View' : '';
    action.onclick = () => {
      el.classList.remove('is-visible');
      const open = document.querySelector('.header__icons open-wishlists-button');
      if (open) open.click();
    };
    setTimeout(() => el.classList.add('is-visible'), 20);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 5000);
  };

  /* ---------- the flow, shared by every entry point ----------
     ctx = { variantId, size, title, vendor, image, comingSoon, done(), fail(text) } */
  const sheet = () => {
    let s = document.querySelector('.sp-nm');
    if (s) return s;
    s = document.createElement('div');
    s.className = 'sp-nm';
    s.dataset.open = 'false';
    s.innerHTML = `
      <div class="sp-nm__overlay" data-sp-nm-close></div>
      <div class="sp-nm__panel" role="dialog" aria-modal="true" aria-labelledby="SpNmTitle">
        <div class="sp-nm__header">
          <h2 class="sp-nm__title" id="SpNmTitle">Notify me</h2>
          <button type="button" class="sp-nm__close" aria-label="Close" data-sp-nm-close></button>
        </div>
        <div class="sp-nm__body"></div>
      </div>`;
    document.body.appendChild(s);
    s.addEventListener('click', (e) => { if (e.target.closest('[data-sp-nm-close]')) closeSheet(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && s.dataset.open === 'true') closeSheet(); });
    return s;
  };
  const closeSheet = () => {
    const s = document.querySelector('.sp-nm');
    if (!s) return;
    s.dataset.open = 'false';
    document.body.classList.remove('overflow-hidden');
  };
  const openSheet = (ctx, need) => {
    const s = sheet();
    const guest = ls.get(GUEST_KEY, {});
    const email = loggedIn ? (me.email || '') : (guest.email || '');
    const lead = ctx.comingSoon
      ? `Be the first to know when this lands. We’ll let you know as soon as ${ctx.size ? 'your size arrives' : 'it arrives'}.`
      : `${ctx.size ? 'This size is' : 'This is'} sold out. We’ll let you know as soon as it’s back in stock.`;
    s.querySelector('.sp-nm__body').innerHTML = `
      <div class="sp-nm__product">
        ${ctx.image ? `<img class="sp-nm__img" src="${esc(ctx.image)}" alt="" width="80" height="107">` : ''}
        <div class="sp-nm__info">
          ${ctx.vendor ? `<p class="sp-nm__vendor">${esc(ctx.vendor)}</p>` : ''}
          <p class="sp-nm__name">${esc(ctx.title)}</p>
          ${ctx.size ? `<p class="sp-nm__size">Size: ${esc(ctx.size)}</p>` : ''}
        </div>
      </div>
      <p class="sp-nm__copy">${lead}</p>
      <form class="sp-nm__form" novalidate>
        <label class="sp-nm__label" for="SpNmEmail">Email</label>
        <input class="sp-nm__input" id="SpNmEmail" type="email" name="email" autocomplete="email" required placeholder="Email address" value="${esc(email)}" ${loggedIn && email ? 'readonly' : ''}>
        ${CONFIG.smsEnabled ? `<fieldset class="sp-nm__channels">
          <legend class="sp-nm__label">How should we let you know?</legend>
          <div class="sp-nm__pills">
            <label class="sp-nm__pill"><input type="radio" name="channel" value="email"${need.channel === 'email' ? ' checked' : ''}><span>Email</span></label>
            <label class="sp-nm__pill"><input type="radio" name="channel" value="sms"${need.channel === 'sms' ? ' checked' : ''}><span>Text</span></label>
            <label class="sp-nm__pill"><input type="radio" name="channel" value="both"${need.channel === 'both' ? ' checked' : ''}><span>Both</span></label>
          </div>
        </fieldset>
        ${need.phone ? '' : `
        <div class="sp-nm__phone">
          <label class="sp-nm__label" for="SpNmPhone">Mobile</label>
          <input class="sp-nm__input" id="SpNmPhone" type="tel" name="phone" autocomplete="tel" inputmode="tel" placeholder="Mobile number">
        </div>`}` : ''}
        <label class="sp-nm__check sp-nm__consent sp-nm__consent--email" hidden>
          <input type="checkbox" name="emailConsent">
          <span>Also send me Superette emails: new arrivals, early access and offers.</span>
        </label>
        ${CONFIG.smsEnabled ? `<label class="sp-nm__check sp-nm__consent sp-nm__consent--sms" hidden>
          <input type="checkbox" name="smsConsent">
          <span>Text me this alert, plus Superette updates. Msg &amp; data rates may apply. Reply STOP to opt out.</span>
        </label>` : ''}
        <button class="sp-nm__btn" type="submit">Notify me</button>
        <p class="sp-nm__error" role="alert" hidden></p>
        <p class="sp-nm__legal"></p>
      </form>`;
    const form = s.querySelector('form');
    // the mobile field + the legal line follow the channel they pick
    const legal = form.querySelector('.sp-nm__legal');
    // opt-in box: anyone not yet subscribed, or a guest who changes the remembered email to a different one
    const askEmailOptIn = () => need.emailOptIn || (!loggedIn && form.email.value.trim().toLowerCase() !== String(guest.email || '').toLowerCase());
    form.askEmailOptIn = askEmailOptIn;
    const sync = (focus) => {
      const c = pickChannel(form.channel && form.channel.value);
      const askPhone = usesSms(c) && !need.phone;
      form.classList.toggle('has-sms', askPhone);
      if (askPhone && focus && form.phone) form.phone.focus();
      // consent boxes: never pre-ticked, only shown for the channel(s) chosen
      form.querySelector('.sp-nm__consent--email').hidden = !(usesEmail(c) && askEmailOptIn());
      const smsBox = form.querySelector('.sp-nm__consent--sms');
      if (smsBox) smsBox.hidden = !usesSms(c);
      const parts = [];
      if (usesSms(c) && need.phone) parts.push('We’ll text your mobile on file.');
      parts.push('Unsubscribe anytime.');
      legal.innerHTML = `${parts.map(esc).join(' ')} <a href="${CONFIG.privacyUrl}">Privacy policy</a>`;
    };
    form.querySelectorAll('input[name="channel"]').forEach((r) => r.addEventListener('change', () => sync(true)));
    form.email.addEventListener('input', () => sync(false)); // a guest typing a different email gets the opt-in box again
    sync(false);
    form.addEventListener('submit', (e) => { e.preventDefault(); submitSheet(ctx, form, need); });
    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      s.dataset.open = 'true';
      const first = form.email.readOnly ? form.querySelector('.sp-nm__btn') : form.email;
      if (first) first.focus({ preventScroll: true });
    }, 20);
  };
  const success = (ctx) => {
    const s = document.querySelector('.sp-nm');
    const size = ctx.size ? ` in ${ctx.size}` : '';
    s.querySelector('.sp-nm__body').innerHTML = `
      <div class="sp-nm__done" role="status">
        <p class="sp-nm__heading">You’re on the list</p>
        <p class="sp-nm__copy">We’ll let you know as soon as ${ctx.comingSoon ? `it lands${ctx.size ? ` in size ${esc(ctx.size)}` : ''}` : `${ctx.size ? `size ${esc(ctx.size)}` : 'it'} is back in stock`}.${loggedIn ? ' You’ll find it in your Notify Me list.' : ''}</p>
        <button type="button" class="sp-nm__btn sp-nm__btn--alt" data-sp-nm-close>Continue shopping</button>
      </div>`;
  };
  const markDone = (ctx) => {
    const done = ls.get(DONE_KEY, []);
    if (!done.includes(String(ctx.variantId))) { done.push(String(ctx.variantId)); ls.set(DONE_KEY, done.slice(-200)); }
    markCards();
    if (ctx.done) ctx.done();
  };

  const submitSheet = async (ctx, form, need) => {
    const err = form.querySelector('.sp-nm__error');
    const email = form.email.value.trim();
    const channel = pickChannel(form.channel && form.channel.value);
    const wantEmail = !!(form.askEmailOptIn ? form.askEmailOptIn() : need.emailOptIn) && usesEmail(channel) && !!form.emailConsent.checked; // optional: the alert is sent either way
    const wantSms = usesSms(channel);
    const phone = need.phone || (wantSms ? toE164(form.phone && form.phone.value) : '');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; return; }
    if (wantSms && !/^\+\d{8,15}$/.test(phone)) { err.textContent = 'Please check your mobile number.'; err.hidden = false; return; }
    if (wantSms && !(form.smsConsent && form.smsConsent.checked)) { err.textContent = 'Please tick the box to get your alert by text.'; err.hidden = false; return; }
    err.hidden = true;
    form.classList.add('is-loading');
    let ok = false;
    try {
      const [m, b] = await Promise.all([
        subscribeMarketing(email, phone, wantEmail, wantSms),
        subscribeBis(ctx.variantId, email, phone, channel),
        saveChannel(email, phone, channel),
      ]);
      ok = b; // the alert is what matters; a failed marketing opt-in shouldn't block it
      if (!m) console.warn('[Notify me] marketing opt-in failed');
      if (ok) {
        ls.set(CHANNEL_KEY, channel);
        if (wantSms && phone && loggedIn) me.phone = phone;
        if (m && wantEmail && loggedIn) me.acceptsMarketing = true; // don't offer the opt-in again this visit
        if (!loggedIn) {
          const g = ls.get(GUEST_KEY, {});
          ls.set(GUEST_KEY, { email, emailSubscribed: (m && wantEmail) || (!!g.emailSubscribed && String(g.email || '').toLowerCase() === email.toLowerCase()) }); // email only — never the mobile
        }
        if (loggedIn) await saveToFish(ctx.variantId);
        trackNotify(ctx, email, channel, m && wantEmail);
      }
    } catch (x) { ok = false; }
    form.classList.remove('is-loading');
    if (!ok) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; return; }
    markDone(ctx);
    success(ctx);
  };

  const notify = async (ctx) => {
    if (!ctx.variantId) return;
    const guest = ls.get(GUEST_KEY, {});
    const email = loggedIn ? (me.email || '') : (guest.email || '');
    const emailSubscribed = loggedIn ? !!me.acceptsMarketing : !!guest.emailSubscribed;
    const phone = loggedIn && CONFIG.smsEnabled ? toE164(me.phone || '') : '';
    const saved = ls.get(CHANNEL_KEY, '');
    const channel = pickChannel(saved);
    const need = { emailOptIn: !emailSubscribed, phone, channel };
    // v1.8: no one tap — everyone (signed in or not) gets the sheet each time, email pre-filled when signed in,
    // so it's clear they're signing up and they can opt in to emails
    openSheet(ctx, need);
  };

  /* =====================================================================
     1. PDP button
     ===================================================================== */
  const btn = () => document.querySelector('[data-sp-notify]');
  const atc = () => document.querySelector('.product-form__submit');
  const variantInput = () => document.querySelector('product-info form[action*="/cart/add"] [name="id"], form[action*="/cart/add"][id^="product-form"] [name="id"]');
  let sizeChosen = new URLSearchParams(location.search).has('variant');
  let current = null; // { id, title, notify }

  // the PDP's own picker only (never a card's or the quick add drawer's)
  const checkedInputs = () => [...document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select option:checked')]
    .filter((i) => !i.closest('.card-wrapper, .product-card-wrapper-TWP, quick-add-drawer, quick-add-inline'));
  const isNotifyVariant = (variant) => {
    const b = btn();
    if (!b) return false;
    if (b.dataset.comingSoon === 'true') return true;
    if (variant && typeof variant.available === 'boolean') return !variant.available;
    return checkedInputs().some((i) => i.hasAttribute('data-variant-notify-me'));
  };
  // the size the shopper sees (deduped: some variant titles repeat the size, e.g. "7 / 7")
  const variantTitle = (variant) => {
    let parts = checkedInputs().map((i) => (i.value || '').trim());
    if (!parts.filter(Boolean).length && variant && variant.title) parts = String(variant.title).split(' / ');
    return [...new Set(parts.map((v) => v.trim()).filter((v) => v && v !== 'Default Title'))].join(' / ');
  };
  const singleVariant = () => (btn() && btn().dataset.single === 'true');

  // v1.3: the size comes straight from the picker (matched against the product JSON), not
  // from the theme's hidden variant input. That input only updates once the theme's section
  // refresh comes back (1–2s on mobile), so a quick tap on Notify me said "Please select a
  // size" — or could sign up for the previously selected size.
  let productJson = null;
  let productLoad = null;
  const loadProduct = () => {
    if (productLoad) return productLoad;
    const pi = document.querySelector('product-info[data-url]');
    const url = pi && pi.dataset.url ? pi.dataset.url.split('?')[0] : '';
    productLoad = url
      ? fetch(`${url}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((j) => { productJson = j; return j; })
        .catch(() => null)
      : Promise.resolve(null);
    return productLoad;
  };
  const pdpPicker = () => [...document.querySelectorAll('variant-selects')]
    .find((v) => !v.closest('.card-wrapper, .product-card-wrapper-TWP, quick-add-drawer, quick-add-inline')) || null;
  const pickerVariant = () => {
    const p = productJson;
    if (!p || !Array.isArray(p.variants) || !p.variants.length) return null;
    if (p.variants.length === 1) return p.variants[0];
    const picker = pdpPicker();
    if (!picker) return null;
    const groups = [...picker.querySelectorAll('[data-option-name]')];
    const values = (p.options || []).map((o) => {
      const name = String((o && o.name) || o).trim().toLowerCase();
      const g = groups.find((x) => String(x.dataset.optionName || '').trim().toLowerCase() === name);
      if (!g) return o && Array.isArray(o.values) && o.values.length === 1 ? String(o.values[0]).trim() : null;
      const input = g.querySelector('input:checked');
      if (input) return String(input.value).trim();
      const select = g.querySelector('select');
      return select && select.value ? String(select.value).trim() : null;
    });
    if (!values.length || values.some((v) => !v)) return null;
    return p.variants.find((v) => (v.options || []).every((x, k) => String(x).trim() === values[k])) || null;
  };

  // v1.4: on the list = this device's sign-ups or (signed in) the Fish Waitlist (WL10)
  const onList = (id) => {
    if (!id) return false;
    if (isDone(id)) return true;
    const w = window.FishWishlist && window.FishWishlist.wishlists && window.FishWishlist.wishlists.WL10;
    return Array.isArray(w) && w.some((x) => String(x && x.id) === String(id));
  };
  const pdpChosen = () => {
    const b = btn();
    return singleVariant() || sizeChosen || !!(b && b.dataset.noPreselect === 'true' && current && current.id && pickerVariant());
  };

  const render = (variant) => {
    const b = btn();
    if (!b) return;
    const input = variantInput();
    const picked = pickerVariant();
    if (picked) variant = picked;
    const id = (picked && picked.id) || (variant && variant.id) || (input && input.value) || b.dataset.variantId;
    current = { id: id ? String(id) : null, title: singleVariant() ? '' : variantTitle(variant), notify: isNotifyVariant(variant) };
    b.classList.toggle('visually-hidden', !current.notify);
    const add = atc();
    if (add) add.classList.toggle('visually-hidden', current.notify);
    // v1.4: first landing (no size chosen yet) always reads CHOOSE SIZE like every other product;
    // YOU'RE ON THE LIST only once they pick a size they've already signed up to
    const label = b.querySelector('span');
    const chosen = pdpChosen();
    const done = chosen && onList(current.id);
    const text = done ? 'You’re on the list' : (chosen ? 'Notify me' : 'Choose size');
    if (label && label.textContent !== text) label.textContent = text;
    b.classList.toggle('is-done', done);
    b.classList.toggle('sp-notify--choose', !chosen && !done);
    hideError();
  };
  const showError = (text) => {
    const b = btn();
    if (!b) return;
    let e = document.querySelector('.sp-notify-error');
    if (!e) { e = document.createElement('p'); e.className = 'sp-notify-error'; e.setAttribute('role', 'alert'); (b.closest('.product-form__buttons') || b).after(e); }
    e.textContent = text;
  };
  const hideError = () => { const e = document.querySelector('.sp-notify-error'); if (e) e.remove(); };

  const onPdpNotify = async (e) => {
    e.preventDefault();
    await loadProduct();
    render();
    const b0 = btn();
    // themes that don't preselect a size (TWP 1.7.0+) mark the button data-no-preselect:
    // there, any selected size was chosen by the shopper
    const chosen = singleVariant() || sizeChosen || (b0 && b0.dataset.noPreselect === 'true' && current && current.id);
    if (!current || !current.id || !chosen) {
      showError('Please select a size.');
      const picker = document.querySelector('variant-selects');
      if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!current.notify) return; // an in-stock size: Add to cart is showing instead
    const b = btn();
    notify({
      variantId: current.id,
      size: current.title,
      title: b.dataset.productTitle,
      vendor: b.dataset.vendor,
      image: b.dataset.image,
      comingSoon: b.dataset.comingSoon === 'true',
      productUrl: (document.querySelector('product-info[data-url]') || {}).dataset ? document.querySelector('product-info[data-url]').dataset.url : location.pathname,
      source: 'Product page',
      busy: (on) => { const x = btn(); if (x) { x.classList.toggle('is-loading', on); x.toggleAttribute('aria-busy', on); } },
      fail: showError,
      done: () => render(),
    });
  };

  /* =====================================================================
     2. Cards, recommenders, mobile quick add: the theme's notify sizes
        ([data-notify-me-trigger]) open our flow instead of the old TWC drawer
     ===================================================================== */
  const cardOf = (el) => el.closest('.product-card-wrapper-TWP, .card-wrapper, .product-card, .cart-drawer-mini-card');
  const imgSrc = (img) => {
    if (!img) return '';
    const src = img.currentSrc || img.getAttribute('src') || '';
    return src.startsWith('//') ? `https:${src}` : src;
  };
  const ctxFromCard = (button) => {
    const card = cardOf(button);
    const sizes = card ? [...card.querySelectorAll('.quick-add-inline-desktop__size-btn')] : [];
    const one = sizes.length <= 1;
    const heading = card && card.querySelector('.card__heading a, .card__heading, .product-title, h3');
    const vendor = card && card.querySelector('.card__vendor, .caption-with-letter-spacing');
    return {
      variantId: button.dataset.variantIdNotify || button.dataset.variantId,
      size: one ? '' : (button.dataset.size || ''),
      title: heading ? heading.textContent.trim() : '',
      vendor: vendor ? vendor.textContent.trim() : '',
      image: imgSrc(card && card.querySelector('.card__media img, img')),
      productUrl: ((card && card.querySelector('a[href*="/products/"]')) || {}).href || '',
      source: 'Collection card',
      // coming soon = every size on the card is a notify size
      comingSoon: !!(card && card.querySelector('.card__badge, .badge') && /coming soon/i.test(card.querySelector('.card__badge, .badge').textContent)) || (sizes.length > 0 && sizes.every((s) => s.hasAttribute('data-notify-me-trigger'))),
      busy: (on) => button.classList.toggle('quick-add-inline-desktop__size-btn--loading', on),
      fail: () => {},
    };
  };
  const ctxFromQuickAddDrawer = (button, drawer) => {
    const p = drawer.currentProduct || {};
    const one = (p.sizes || []).length <= 1;
    const firstImage = p.images && p.images[0] ? p.images[0].url : '';
    return {
      variantId: button.dataset.variantIdNotify || button.dataset.variantId,
      size: one ? '' : (button.dataset.size || ''),
      title: p.title || '',
      vendor: p.vendor || '',
      image: firstImage && firstImage.startsWith('//') ? `https:${firstImage}` : firstImage,
      comingSoon: !!p.isComingSoon,
      productUrl: p.url || (p.handle ? `/products/${p.handle}` : ''),
      source: 'Quick add',
      fail: () => {},
    };
  };
  document.addEventListener('click', (e) => {
    const button = e.target.closest && e.target.closest('[data-notify-me-trigger]');
    if (!button || button.closest('.sp-nm')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const qad = button.closest('quick-add-drawer');
    if (qad) {
      const ctx = ctxFromQuickAddDrawer(button, qad);
      if (typeof qad.close === 'function') qad.close();
      notify(ctx);
      return;
    }
    notify(ctxFromCard(button));
  }, true);

  // show which sizes they're already on the list for
  const markCards = () => {
    const done = ls.get(DONE_KEY, []);
    if (!done.length) return;
    document.querySelectorAll('[data-notify-me-trigger]').forEach((b) => {
      const on = done.includes(String(b.dataset.variantIdNotify || b.dataset.variantId));
      if (b.classList.contains('sp-notified') !== on) b.classList.toggle('sp-notified', on);
    });
  };

  /* ---------- wiring ---------- */
  const bindPdp = () => {
    const b = btn();
    if (!b || b.dataset.spBound) return;
    b.dataset.spBound = 'true';
    b.addEventListener('click', onPdpNotify);
    render();
    loadProduct().then(() => render());
    setTimeout(() => render(), 2500); // the Fish Waitlist (signed in) loads after the page
  };
  const init = () => {
    bindPdp();
    markCards();
    document.addEventListener('change', (e) => {
      if (!(e.target.closest && e.target.closest('variant-selects, variant-radios'))) return;
      if (!btn()) return;
      if (e.isTrusted) sizeChosen = true;
      setTimeout(() => render(), 0);
      setTimeout(() => render(), 700); // the variant id input updates after the theme's fetch
    }, true);
    // tapping the size that's already highlighted fires no change event: count the tap as a choice
    document.addEventListener('click', (e) => {
      if (e.isTrusted && e.target.closest && e.target.closest('variant-selects label, variant-selects input, variant-radios label')) { sizeChosen = true; hideError(); }
    }, true);
    // theme pubsub (PUB_SUB_EVENTS is a top-level const, so it isn't on window)
    try {
      // eslint-disable-next-line no-undef
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        // eslint-disable-next-line no-undef
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => render(event && event.data && event.data.variant));
      }
    } catch (e) { /* the change listener above still covers it */ }
    // re-renders (variant change, filters, recommenders loading in, quick add drawer filling)
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => { queued = false; bindPdp(); markCards(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
